const UP_SDK = require('./build/js/main.js');
module.exports = UP_SDK;
